let deferredPrompt = null;

const isStandalone =
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true;

const isIOS =
  /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const isHomePage =
  location.pathname === "/" ||
  location.pathname === "/index" ||
  location.pathname === "/index.html";

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
  showInstallPopup();
});

async function installPWA() {
  if (!deferredPrompt) return;
  deferredPrompt.prompt();
  await deferredPrompt.userChoice;
  deferredPrompt = null;
  closePWAPopup();
}

function closePWAPopup() {
  const popup = document.getElementById("pwa-install-popup");
  if (popup) popup.classList.remove("show");
}

function showInstallPopup() {
  if (isStandalone) return;

  const popup = document.getElementById("pwa-install-popup");
  const title = document.getElementById("pwa-title");
  const text = document.getElementById("pwa-text");
  const installBtn = document.getElementById("pwa-install-btn");

  if (!popup || !text) return;

  popup.classList.add("show");

  // ================================
  // iOS (GUIA VISUAL)
  // ================================
  if (isIOS) {
    if (title) title.innerText = "Añade Club HOOSH a tu iPhone";

    text.innerHTML = `
  <p class="pwa-hint">⬅️ Desliza para ver los pasos</p>

  <div class="pwa-carousel">
    <div class="pwa-carousel-track">

      <div class="pwa-slide">
        <img src="${window.PWA_IMAGES.share}" alt="Toca Compartir">
        <p>Toca el botón <b>Compartir</b></p>
      </div>

      <div class="pwa-slide">
        <img src="${window.PWA_IMAGES.add}" alt="Añadir a inicio">
        <p>Selecciona <b>Añadir a pantalla de inicio</b></p>
      </div>

    </div>
  </div>

  <div class="pwa-dots">
    <span class="pwa-dot active"></span>
    <span class="pwa-dot"></span>
  </div>
`;


    if (installBtn) installBtn.style.display = "none";

  } else {
    if (title) title.innerText = "Instala la app de Club HOOSH";
    if (installBtn) installBtn.style.display = "block";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (isIOS && !isStandalone && isHomePage) {
    setTimeout(showInstallPopup, 1200);
  }
});

document.addEventListener("scroll", () => {
  const carousel = document.querySelector(".pwa-carousel");
  const dots = document.querySelectorAll(".pwa-dot");
  if (!carousel || dots.length === 0) return;

  const scrollLeft = carousel.scrollLeft;
  const width = carousel.offsetWidth;
  const index = Math.round(scrollLeft / width);

  dots.forEach((dot, i) => {
    dot.classList.toggle("active", i === index);
  });
}, true);
